import { Component, OnInit, OnDestroy } from '@angular/core';
import { ShoppingCartService } from 'src/app/shared/services/shopping-cart.service';
import { DataService } from 'src/app/shared/services/data.service';
import { Subscriber, Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'shop-header',
  templateUrl: './shop-header.component.html',
  styleUrls: ['./shop-header.component.scss']
})
export class ShopHeaderComponent implements OnInit , OnDestroy {
  totalItemCount: number;
  subscription : Subscription;
  merchantUrl: string ;
  merchantName: string ;
  merchant: any = {};
  storeName: string;
  merchantSubscription : Subscription;
  
  constructor(private cartServices: ShoppingCartService,private dataService: DataService , private router : Router) { }

  ngOnInit() {
    this.getMerchant();
    this.cartServices.init();
   this.totalItemCount = this.cartServices.totalItemsCount;
   this.subscription = this.dataService.cartQtySubject.subscribe(count => {
      this.totalItemCount = count;
    });
  }

  getMerchant() {
   this.merchantSubscription = this.dataService.merchantDetails.subscribe(data =>{
      this.merchant = data;
      // console.log(this.merchant);
      this.merchantName = this.merchant.companyName ;
      this.storeName = this.merchant.tenantId;
      // console.log(this.storeName);
      console.log(this.merchant);
      
      
    });
  }


  goToProducts(){
    this.router.navigate(['/']);
  }

  ngOnDestroy(){
    this.subscription.unsubscribe;
    this.merchantSubscription.unsubscribe;
  }
}
